<template lang="pug">
  .b-pagination(v-if="dataLength" :class="{ vertically: device === 'mobile' }")
    .__page-sizes(:class="{'visibility-hidden': !isNeededPageSizes}")
      BaseSelect(:options="pageSizes" label="Выводить по:" labelOuter :value="internalPageSize" pageSize
        hideNotSelected notSelectedLabel="Нет" @change="changeInternalPageSize")
    .__pages-container
      .__page-arrow.prev(@click="changeInternalPage(internalActivePage - 1)" :class="{disabled: internalActivePage === 1}")
        Icon(name="angle-right" :pointer="internalActivePage !== 1")
      ._page(v-if="!pageRange.includes(1)" @click="changeInternalPage(1)") 1
      ._page(v-if="pageRange[0] > 2" @click="changeInternalPage(Math.floor((internalActivePage + 1) / 2))") ...
      ._page(v-for="page in pageRange" :class="{ active: page === internalActivePage, margined: (`${page}`).length > 1 }" @click="changeInternalPage(page)") {{ page }}
      ._page(v-if="pageRange[pageRange.length - 1] < pagesCount - 1" @click="changeInternalPage(Math.floor((pagesCount + internalActivePage) / 2))") ...
      ._page(v-if="!pageRange.includes(pagesCount)" @click="changeInternalPage(pagesCount)" :class="{margined: (`${pagesCount}`).length > 1}") {{ pagesCount }}
      .__page-arrow.next(@click="changeInternalPage(internalActivePage + 1)" :class="{disabled: internalActivePage === pagesCount}")
        Icon(name="angle-right" :pointer="internalActivePage !== pagesCount")
    .__page-info(:class="{'visibility-hidden': !isNeededPageInfo}")
      | {{ ((internalActivePage - 1)*internalPageSize) + 1 }} - {{ (internalActivePage*internalPageSize < dataLength) ? internalActivePage*internalPageSize : dataLength }} из {{ dataLength }}

</template>

<script>
import BaseSelect from '@/components/BaseSelect.vue';

export default {
  name: 'Pagination',
  components: { BaseSelect },
  props: {
    dataLength: {
      type: Number,
      default: 0,
    },
    externalPageSize: {
      type: Number,
      default: 10,
    },
    externalActivePage: {
      type: Number,
      default: 1,
    },
    isNeededPageSizes: {
      type: Boolean,
      default: true,
    },
    isNeededPageInfo: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    internalPageSize() {
      this.$nextTick(() => {
        this.pageRange = this.createArrayFromRange(1, this.rangeValue);
        this.internalActivePage = 1;
      });
    },
    dataLength() {
      this.$nextTick(() => {
        this.pageRange = this.createArrayFromRange(1, this.rangeValue);
        this.internalActivePage = 1;
      });
    },
    externalPageSize(pageSize) {
      this.internalPageSize = pageSize;
    },
    externalActivePage(page) {
      this.setPageWithRange(page);
    },
  },
  data() {
    return {
      internalPageSize: this.externalPageSize || 12,
      internalActivePage: this.externalActivePage || 1,
      pageRange: [],
      pageSizes: [],
      device: 'desktop',
    };
  },
  created() {
    this.pageRange = this.createArrayFromRange(1, 3);
    let pageSize = 12;
    for (let i = 0; i < 4; i++) {
      this.pageSizes.push({ label: `${pageSize}`, value: pageSize });
      pageSize *= 2;
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkResize);
    this.checkResize();
  },
  beforeDestroy() {
    document.removeEventListener('resize', this.checkResize);
  },
  computed: {
    pagesCount() {
      const roundedPage = Math.floor(this.dataLength / this.internalPageSize);
      const exactPage = this.dataLength / this.internalPageSize;
      return (roundedPage === exactPage) ? roundedPage : roundedPage + 1;
    },
    rangeValue() {
      return ((this.pagesCount < 5) && +this.pagesCount) ? this.pagesCount : 5;
    },
  },
  methods: {
    changeInternalPageSize(pageSize) {
      this.$emit('changePageSize', pageSize);
    },
    changeInternalPage(page) {
      this.$emit('changePage', page);
    },
    createArrayFromRange(start, end) {
      const range = {
        start: (start <= 0) ? 1 : start,
        end: (end > this.pagesCount) ? this.pagesCount : end,
      };
      return Array(range.end - range.start + 1).fill().map((_, idx) => range.start + idx);
    },
    setPageWithRange(page) {
      const range = [page - 2, page + 2];
      this.pageRange = this.createArrayFromRange(...range);
      this.internalActivePage = page;
    },
    checkResize() {
      if (window.innerWidth > 1200) this.device = 'desktop';
      else if (window.innerWidth < 768) this.device = 'mobile';
      else this.device = 'tablet';
    },
  },
};
</script>

<style scoped lang="scss">
  .pagination {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    &.vertically {
      flex-direction: column;
      .pagination {
        &__pages-container {
          margin: 20px 0;
        }

        &__page-info {
          text-align: center;
        }
      }
    }

    &__page {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: var(--color-dark-gray);
      cursor: pointer;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;

      &.active {
        background: #33A1FB;
        color: var(--color-white);
      }

      &.margined {
        margin: 0 2px;
      }

      &-arrow {
        width: 10px;
        height: 20px;
        cursor: pointer;
        text-align: center;

        &.disabled {
          pointer-events: none;
          opacity: 0.3;
          cursor: auto;
        }

        svg {
          fill: var(--color-dark-gray);
        }

        &.next {
          margin-left: 5px;
        }

        &.prev {
          margin-right: 5px;
          transform: rotate(180deg);
        }
      }

      &-info {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.01em;
        color: var(--color-light-dark);
        width: 120px;
        text-align: right;

        &.visibility-hidden {
          visibility: hidden;
        }
      }

      &-sizes {
        &.visibility-hidden {
          visibility: hidden;
        }
      }
    }

    &__pages {
      &-container {
        display: flex;
        align-items: center;
      }
    }
  }

</style>
